module.exports = __webpack_public_path__ + "img/youtube.5bc923ea.svg";